import { useState } from 'react';
import { useFormik } from 'formik';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { DialogTitle, DialogContent, DialogActions, ModalColumna, } from '../../usuarios/components/usuariosComponents';
import Dialog from '@mui/material/Dialog';
import { validationSchema } from './validation';
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useAuth } from '../../context/AdminContext';
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 300,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
  dividerFullWidth: {
    margin: `30px 0 0 0`,
  },
}));

function LoginDialog({ modal, toggleModal, toggleModalReset }) {

  const { login, isLoged } = useAuth();
  const navigate = useNavigate();
  const location = useLocation()
  const [verPass, setVerPass] = useState(false);


  const classes = useStyles();
  //const {
  //   setStatus,
  //   history,
  //   onClose,
  //   openChangePasswordDialog,
  //   status,
  //  } = props;


  const initialValues = {
    email: "",
    contraseña: "",
  }

  const submitUser = async (values) => {
    const success = await login(values.email, values.contraseña)
    if (success) handleClose();
    else formik.resetForm();
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: submitUser,
    enableReinitialize: true,
  });

  const handleVisibility = () => {
    setVerPass((prev) => (prev ? false : true))
  }

  const handleClose = () => {
    formik.resetForm();
    toggleModal();
  };

  useEffect(() => {
    if (!isLoged) {
      toggleModal();
      navigate('/')
      return;
    }

    navigate(location.pathname)
  }, [isLoged]);

  return <>
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={modal}
        maxWidth='md'>
        <form onSubmit={formik.handleSubmit} className={classes.form}>
          <DialogTitle id='customized-dialog-title' onClose={handleClose}>
            Iniciar sesion
          </DialogTitle>

          <DialogContent dividers>
            <ModalColumna>
              <TextField
                variant="standard"
                id='email'
                name='email'
                label='Usuario'
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email} />
              <TextField
                variant="standard"
                id='contraseña'
                type={verPass ? "text" : "password"}
                name='contraseña'
                label='Contraseña'
                InputProps={{
                  endAdornment: verPass ? < BsFillEyeFill onClick={handleVisibility} /> : <BsFillEyeSlashFill onClick={handleVisibility} />
                }}
                value={formik.values.contraseña}
                onChange={formik.handleChange}
                error={formik.touched.contraseña && Boolean(formik.errors.contraseña)}
                helperText={formik.touched.contraseña && formik.errors.contraseña} />
            </ModalColumna>

            <Divider className={classes.dividerFullWidth} />
            <Button variant="text" onClick={toggleModalReset}>
              ¿Olvidaste tu contraseña?
            </Button>


          </DialogContent>
          <DialogActions>

            <Button color='primary' variant='contained' type='submit'>
              Ingresar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  </>;
}

LoginDialog.propTypes = {
  modal: PropTypes.bool,
  toggleModal: PropTypes.func,
  modalRest: PropTypes.bool,
  toggleModalReset: PropTypes.func,

  // setStatus: PropTypes.func.isRequired,
  // openChangePasswordDialog: PropTypes.func.isRequired,
  // history: PropTypes.object.isRequired,
  // status: PropTypes.string,
};

export default LoginDialog;
